import { Component } from '@angular/core';

import { CustomPageBlockComponent } from './custom-page-block.component';
@Component({
  selector: 'app-custom-page-repeatable-block',
  template: `<div class="px-8 max-w-screen-2xl mx-auto flex flex-col gap-8">
    @for (group of data().group; track $index) {
      <section>
        <h2 class="text-2xl text-primary font-bold">{{ group.title }}</h2>
        <dl>
          @for (item of group.items; track $index) {
            <dt class="border-b border-gray-500 py-4 [&:has(input:checked)+dd]:block ">
              <!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
              <label
                role="button"
                [attr.aria-expanded]="checkbox.checked"
                class="select-none text-lg font-bold flex flex-row flex-nowrap cursor-pointer [&:has(input:checked)_i]:rotate-180"
              >
                <input type="checkbox" class="hidden" #checkbox />
                {{ item.title }}
                <i class="fa-solid fa-chevron-down text-primary ml-auto"></i>
              </label>
            </dt>
            <dd class="py-4 hidden">
              <div
                class="text-base [&_p]:mb-3 [&_p:last-child]:mb-0 [&_strong]:font-bold [&_em]:italic [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-3 [&_li]:mb-1 [&_a]:text-primary [&_a]:underline hover:[&_a]:no-underline"
                [innerHTML]="item.content"
              ></div>
            </dd>
          }
        </dl>
      </section>
    }
  </div>`,
  standalone: true,
})
export class CustomPageRepeatableBlockComponent extends CustomPageBlockComponent<'repeatable_block'> {}
